// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__6I4qa","rotate":"Loader_rotate__F9_w6","dash":"Loader_dash__NL3h_"};